import { Injectable } from "@angular/core";
import {
  LocationCustomShortLinkDto,
  LocationCustomShortLinkResultDto,
  POSSystemInfo,
  PosSystemReceiptPromotionConfigurationDto,
  PosSystemThankYouPageConfigurationDto
} from "@app/models";
import { AccountPosSystemSettings, AccountPosSystemSettingsDto, PosSystemService as PosSystemServiceApi } from "clearline-api";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class PosSystemService extends PosSystemServiceApi {
  getPosSystems(): Observable<POSSystemInfo[]> {
    return this.api.get(`${this.serviceUrl}`);
  }

  getPosSystemByCode(posSystemById: string): Observable<POSSystemInfo> {
    return this.api.get(`${this.serviceUrl}/code/${posSystemById}`);
  }

  getPosSystemById(posSystemById: number): Observable<POSSystemInfo> {
    return this.api.get(`${this.serviceUrl}/${posSystemById}`);
  }

  savePosSettings(data: AccountPosSystemSettings): Observable<AccountPosSystemSettings> {
    const dto: AccountPosSystemSettingsDto = { ...data, configurationJson: data.configuration };
    return this.api
      .post(`${this.serviceUrl}/settings`, dto)
      .pipe(map((data: AccountPosSystemSettingsDto) => AccountPosSystemSettings.fromDto(data)));
  }

  getReceiptSettings(): Observable<PosSystemReceiptPromotionConfigurationDto> {
    return this.api.get(`${this.serviceUrl}/receiptPromotion`);
  }

  saveReceiptSettings(data: PosSystemReceiptPromotionConfigurationDto): Observable<PosSystemReceiptPromotionConfigurationDto> {
    return this.api.post(`${this.serviceUrl}/receiptPromotion`, data);
  }

  getReceiptCustomUrl(): Observable<LocationCustomShortLinkResultDto[]> {
    return this.api.get(`${this.serviceUrl}/receiptPromotion/customUrls`);
  }

  saveReceiptCustomUrl(list: LocationCustomShortLinkDto[]): Observable<LocationCustomShortLinkDto[]> {
    return this.api.post(`${this.serviceUrl}/receiptPromotion/customUrls`, list);
  }

  getThankYouPageSettings(): Observable<PosSystemThankYouPageConfigurationDto> {
    return this.api.get(`${this.serviceUrl}/thankYouPage`);
  }

  saveThankYouPageSettings(data: PosSystemThankYouPageConfigurationDto): Observable<PosSystemThankYouPageConfigurationDto> {
    return this.api.post(`${this.serviceUrl}/thankYouPage`, data);
  }

  getThankYouPageCustomUrls(): Observable<LocationCustomShortLinkResultDto[]> {
    return this.api.get(`${this.serviceUrl}/thankYouPage/customUrls`);
  }

  saveThankYouPageCustomUrls(list: LocationCustomShortLinkDto[]): Observable<LocationCustomShortLinkDto[]> {
    return this.api.post(`${this.serviceUrl}/thankYouPage/customUrls`, list);
  }
}
